import { validationRegex } from 'utils/validations'

export const validateHexColor = (color) =>
  color?.match(validationRegex?.hexColor) ? color : ''
